import { ModelOptions } from './model-options';

export class RadioModelOptions extends ModelOptions {
    public readonly required: boolean;
    public readonly maxEntries: number;
    public readonly initialSelection: number;
    public readonly invalidSelection: number;
    public readonly readonly: boolean;
    public constructor({
        maxEntries = Infinity,
        required = false,
        initialSelection = 0,
        invalidSelection = -1,
        readonly = false,
    }: {
        maxEntries?: number;
        required?: boolean;
        initialSelection?: number;
        invalidSelection?: number;
        readonly?: boolean;
    } = {}) {
        super();
        this.maxEntries = maxEntries;
        this.required = required;
        this.initialSelection = initialSelection;
        this.invalidSelection = invalidSelection;
        this.readonly = readonly;
    }
}

export class RadioModelOptionsFromJson extends RadioModelOptions {
    public constructor(data: JsonRadioModelOptions) {
        super({
            maxEntries: data.maxEntries ? data.maxEntries : Infinity,
            required: data.required,
            initialSelection: data.initialSelection,
            invalidSelection: data.invalidSelection,
            readonly: data.readonly,
        });
    }
}

export interface JsonRadioModelOptions {
    required: boolean;
    maxEntries: number;
    initialSelection: number;
    invalidSelection: number;
    readonly: boolean;
}
